var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.1185,
    height: 92.1185,
    transform: "translate(0.881348 0.293701)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4336 39.9581L47.5775 44.5119L43.0662 35.3514L45.3995 30.0827C46.0065 29.0131 46.9527 29.0229 47.5443 30.0827L52.4336 39.9581Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0683 35.3562L47.5764 44.5167L29.4177 61.5309L43.0683 35.3562Z",
    fill: "#F57F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75 33.001C58.6176 32.1605 59.516 32.4475 59.745 33.6385L64.4717 61.3058L48.8042 70.7761C48.1601 71.0145 47.4862 71.1616 46.8018 71.213C46.1734 71.1467 45.5572 70.9925 44.9711 70.7549L29.4177 61.5284L57.75 33.001Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0733 35.354L29.4243 61.5287L35.5034 23.2783C35.7276 22.0865 36.4018 21.974 37.0023 23.0231L43.0733 35.354Z",
    fill: "#FFA000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0539,
    height: 48.9125,
    fill: "white",
    transform: "translate(29.4177 22.2996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireBase);
export default __webpack_public_path__ + "static/media/fireBase.95b2bf0ddca0f285a5d58d87d27d3f2b.svg";
export { ForwardRef as ReactComponent };